import { jsx as _jsx } from "react/jsx-runtime";
import { Textfield as InnerTextfield } from '@lichtblick/photon/molecules/legacy-textfield/textfield';
import { useEffect, useState } from 'react';
export const Textfield = ({ forcedError: forcedErrorProp, ...props })=>{
    const [invalidValue, setInvalidValue] = useState(false);
    const [missingValue, setMissingValue] = useState(false);
    const [focussed, setFocussed] = useState(false);
    const [forcedError, setForcedError] = useState(forcedErrorProp ?? undefined);
    useEffect(()=>{
        setForcedError(forcedErrorProp ?? undefined);
    }, [
        forcedErrorProp
    ]);
    return /*#__PURE__*/ _jsx(InnerTextfield, {
        ...props,
        onBlur: (e)=>{
            setFocussed(false);
            setInvalidValue(!e.target.validity.valid && !e.target.validity.valueMissing);
            setMissingValue(e.target.validity.valueMissing);
        },
        onChange: (event)=>{
            setForcedError(undefined);
            setInvalidValue(false);
            props.onChange?.(event);
        },
        onFocus: ()=>{
            setFocussed(true);
        },
        onInvalid: (e)=>{
            e.preventDefault();
            setInvalidValue(!e.currentTarget.validity.valid && !e.currentTarget.validity.valueMissing);
            setMissingValue(e.currentTarget.validity.valueMissing);
        },
        statusLabel: missingValue ? 'Hier fehlt noch eine Angabe' : invalidValue || forcedError ? 'Hier stimmt was nicht.' : undefined,
        statusType: !focussed && (invalidValue || missingValue || forcedError) ? 'error' : 'default'
    });
};

//# sourceMappingURL=Textfield.js.map